export default __webpack_public_path__ + "static/media/Yoni.21fdd41b.jpg";